import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmergencyErrorIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 9,
			r: 8,
			stroke: "white",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.31445,
			y: 4.76465,
			width: 1.82857,
			height: 5.64706,
			rx: .914286,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.31445,
			y: 11.353,
			width: 1.82857,
			height: 1.88235,
			rx: .914286,
			fill: "white"
		})
	]
});
export default SvgEmergencyErrorIcon;
